export default __webpack_public_path__ + "static/media/back.e8e05e7c.svg";